import { render, staticRenderFns } from "./DocumentDownloadSVG.vue?vue&type=template&id=74ff12fa"
import script from "./DocumentDownloadSVG.vue?vue&type=script&lang=js"
export * from "./DocumentDownloadSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports